module.exports = __webpack_public_path__ + "img/purple-header-zh.17d01473.png";